const techRoutes = [
  {
    path: 'schedule-list',
    name: 'schedule-list',
    meta: {
      title: '订单排期',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/technician/schedule-list.vue'], resolve)
  },
  {
    path: 'schedule-detail',
    name: 'schedule-detail',
    meta: {
      title: '排期',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '订单排期',
          path: '/default/schedule-list'
        }
      }
    },
    component: resolve => require(['../views/page/technician/schedule-detail.vue'], resolve)
  },
  {
    path: 'upload',
    name: 'upload',
    meta: {
      title: '上传报告',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/technician/upload.vue'], resolve)
  },
  {
    path: 'upload-report',
    name: 'upload-report',
    meta: {
      title: '上传',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '上传报告',
          path: '/default/upload'
        }
      }
    },
    component: resolve => require(['../views/page/technician/upload-report.vue'], resolve)
  },
  {
    path: 'notice-template',
    name: 'notice-template',
    meta: {
      title: '检查须知模板',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/technician/notice-template.vue'], resolve)
  },
  {
    path: 'treatment-check',
    name: 'treatment-check',
    meta: {
      title: '检查登记',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/technician/treatment-check.vue'], resolve)
  },
  {
    path: 'treatment-check-result',
    name: 'treatment-check-result',
    meta: {
      title: '检查报告',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '检查登记',
          path: '/default/treatment-check'
        }
      }
    },
    component: resolve => require(['../views/page/technician/treatment-check-result.vue'], resolve)
  },
  {
    path: 'bb-cancle-treatment',
    name: 'bb-cancle-treatment',
    meta: {
      title: '退医技',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/technician/bb-cancle-treatment.vue'], resolve)
  },
  {
    path: 'treatment-view',
    name: 'treatment-view',
    meta: {
      title: '看报告',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/technician/treatment-view.vue'], resolve)
  }
]

export default techRoutes
